// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { setPcnData } from 'redux/modules/projectTracker/actions'
import { fetchWrapper } from 'helpers/api'

const getPcnData = () => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const { pcn } = getState().projectTracker
      // if the data isn't expired yet, just return what we have in redux store.
      if (pcn.dataExpiration > Date.now()) {
        return pcn.data
      }

      try {
        const data = await fetchWrapper('/pcn')

        // PORTAL-595 - if project_engineer_name is blank,
        // show project_engineer_email instead.
        data.forEach(d => {
          if (!d.project_engineer_name && d.project_engineer_email) {
            d.project_engineer_name = d.project_engineer_email
          }
        })

        dispatch(setPcnData(data))
        return data
      } catch (err) {
        console.warn(err)
        return []
      }
    })
  )
)

export default getPcnData
